import button from './SearchButton.vue'
const SearchButton = {
  install: function (Vue) {
    Vue.component('SearchButton', button)
  }
}
export default SearchButton
